import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Home from 'pages/Home';
import EventViewer from '../pages/EventViewer';
import Help from '../pages/Help';
import Terms from '../pages/Terms';
import Privacy from '../pages/Privacy';

function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/search/:caseId/:eventDate" component={Home} />
      <Route path="/events/" component={EventViewer} />
      <Route path="/help" component={Help} />
      <Route path="/terms" component={Terms} />
      <Route path="/privacy" component={Privacy} />
    </Switch>
  );
}

Routes.EventViewer = EventViewer;

export default Routes;
